"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("@voltmoney/types");
const lodash_es_1 = require("lodash-es");
let _globalProps = {
    widgetRegistry: {},
    routeMap: {},
    ref: {},
    config: {
        [types_1.CONFIG_KEYS.CURRENT_URL_ADDRESS]: '',
    },
};
function setGlobalProps(props) {
    return __awaiter(this, void 0, void 0, function* () {
        const existingConfig = _globalProps.config;
        _globalProps = yield props;
        _globalProps.config = existingConfig;
    });
}
function getPropsValue(key) {
    if (_globalProps && key) {
        return _globalProps[key];
    }
    return null;
}
function setWidgetRefMap(widgetId, widgetRef) {
    return __awaiter(this, void 0, void 0, function* () {
        _globalProps.ref[widgetId] = widgetRef;
    });
}
function getWidgetRef(widgetId) {
    return _globalProps.ref[widgetId];
}
function setConfig(key, value) {
    if (value)
        (0, lodash_es_1.set)(_globalProps, `config.${key}`, value);
}
function getConfig(key) {
    return (0, lodash_es_1.get)(_globalProps, `config.${key}`, null);
}
exports.default = {
    setGlobalProps,
    getPropsValue,
    setWidgetRefMap,
    getWidgetRef,
    setConfig,
    getConfig,
};
//# sourceMappingURL=SharedPropsService.js.map